import { IndustryPageTemplate } from "@/components/templates/IndustryPageTemplate";
import { aiContentCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiContentCluster.industryPages.find(p => p.slug === "seo-content-technology")!;
const relatedMoney = getRelatedMoneyPages("ai-content").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-content").map(p => ({ title: p.title, slug: p.slug }));

export default function SEOContentTechnologyPage() {
  return (
    <IndustryPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
